import React from "react";
import { connect } from "react-redux";
import {
    getArticleOutletName,
    getArticleUrl,
} from "../../../redux/selectors/articles";
import { getAssociatedArticlesLinkStyling } from "../../../redux/selectors/template";

/**
 * display a formatted associated article
 * @param props
 * @returns {*}
 * @constructor
 */
const AssociatedArticle = props => {
    const {
        outletName,
        articleUrl,
        linkStyling,
        associatedArticlesLabelStyling,
        lastItem,
    } = props;

    const getComma = () => {
        if (!lastItem) {
            return <span style={associatedArticlesLabelStyling}>,</span>;
        } else {
            return null;
        }
    };

    if (articleUrl && articleUrl !== "") {
        return (
            <li className="d-inline pl-2">
                <a href={articleUrl} style={linkStyling}>
                    {outletName}
                </a>
                {getComma()}
            </li>
        );
    } else {
        return (
            <li className="d-inline pl-2">
                {outletName}
                {getComma()}
            </li>
        );
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @param ownProps
 * @returns {}
 */
const mapStateToProps = (state, ownProps) => {
    const { giItem } = ownProps;

    return {
        outletName: getArticleOutletName(state, giItem),
        articleUrl: getArticleUrl(state, giItem),
        linkStyling: getAssociatedArticlesLinkStyling(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AssociatedArticle);
